import logo from './logo.svg';
import './App.css';
import LaunchingSoon from './screens/LaunchingSoon/LaunchingSoon';

function App() {
  return (
    <LaunchingSoon />
  );
}

export default App;
